import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Button, FieldGroup, TextField } from '../../../../../components';
import { useStore } from '../../../../../store';
import ExportKeysDialog, { showExportKeysDialog } from './ExportKeysDialog';
import KeyLabelField from './KeyLabelField';

const MAX_LIMIT = 1000;

export default observer(function GeneratePanel({
  productId,
  onCreated,
}: {
  onCreated: () => void;
  productId: string;
}) {
  const { pulseKeyStore } = useStore();
  const [count, setCount] = useState('10');
  const [label, setLabel] = useState('');

  async function onGenerateClick() {
    const generatedKeys = await pulseKeyStore.generateKeys(
      productId,
      Math.min(Number.parseInt(count, 10), MAX_LIMIT),
      label,
    );
    await showExportKeysDialog(generatedKeys);
    onCreated();
  }

  return (
    <>
      <FieldGroup>
        <TextField
          InputProps={{
            inputProps: { min: 1, max: MAX_LIMIT },
          }}
          label="Count"
          onChange={(e) => setCount(e.target.value)}
          sx={{ mt: 0, width: 80 }}
          type="number"
          value={count}
        />
        <KeyLabelField
          emptyTitle="Without label"
          label="Apply label"
          labelCreating
          onChange={setLabel}
          sx={{ mt: 0, width: 240 }}
          value={label}
        />
      </FieldGroup>

      <div>
        <Button
          disabled={!Number.parseInt(count, 10)}
          onClick={onGenerateClick}
          sx={{ mt: 1 }}
          type="primaryText"
        >
          Generate
        </Button>
      </div>

      <ExportKeysDialog />
    </>
  );
});
